import React from 'react';
import {motion} from 'framer-motion';

import SummaryCard from './SummaryCard';
import styles from './styles/admin-01.module.css';

import {ReactComponent as DashboardImg} from '../../assets/admin01/dashboard.svg';
import {ReactComponent as DocumentImg} from '../../assets/admin01/document.svg';
import {ReactComponent as FeedbackImg} from '../../assets/admin01/feedback.svg';
import {ReactComponent as ScenarioImg} from '../../assets/admin01/scenario.svg';
import {ReactComponent as TTImg} from '../../assets/admin01/tt.svg';
import {ReactComponent as ViewTableImg} from '../../assets/admin01/view-table.svg';
import {ReactComponent as VocaImg} from '../../assets/admin01/voca.svg';

export default function Admin01() {
    const springMotion = {
        type: 'spring',
        mass: 1,
        stiffness: 80,
        damping: 15,
        duration: 0.5
    };

    const slideMotion = {
        x: ["0%", "-50%"],
        transition: {
            x: {
                repeat: Infinity,
                repeatType: 'loop',
                duration: 80,
                ease: 'linear',
                delay: 0.6
            }
        },
    };

    const cardMap = [
        { Img: DashboardImg, title: '대시보드', content: '활용 현황을 한눈에 모아보기' },
        { Img: FeedbackImg, title: '피드백 관리', content: '사용자들의 피드백을 모아보기' },
        { Img: ScenarioImg, title: '시나리오 관리', content: '시나리오별 테이블 매핑하기' },
        { Img: VocaImg, title: '단어장', content: 'DB 단어와 실제 단어 매핑하기' },
        { Img: DocumentImg, title: '문서 관리', content: '챗봇 학습 문서 관리하기' },
        { Img: TTImg, title: 'TT 관리', content: '필드와 테이블 관리하기' },
        { Img: ViewTableImg, title: '뷰 테이블 관리', content: '자주 쓰는 필드와 테이블 관리하기' }
    ];

    return (
        <div className={styles.wrapper}>
            <div className={styles.boxTitle}>
                <p className={styles.summary}>관리자 기능</p>
                <div>
                    <motion.p
                        className={styles.title}
                        initial={{ opacity: 0, x: -200 }}
                        animate={{ opacity: 1, x: 0, clipPath: 'inset(0 0 0 0)' }}
                        transition={springMotion}
                    >
                        쉽고 체계적인 관리 도구로<br />
                        <span>AI</span> 챗봇의 성능을 최적화하세요
                    </motion.p>
                </div>
            </div>
            <div className={styles.containerCard}>
                <motion.div
                    className={styles.boxCard}
                    animate={slideMotion}
                >
                    {cardMap.map(({ Img, title, content }, index) => (
                        <SummaryCard
                            key={index}
                            Img={Img}
                            title={title}
                            content={content}
                        />
                    ))}
                    {cardMap.map(({ Img, title, content }, index) => (
                        <SummaryCard
                            key={index}
                            Img={Img}
                            title={title}
                            content={content}
                        />
                    ))}
                    {cardMap.map(({ Img, title, content }, index) => (
                        <SummaryCard
                            key={index}
                            Img={Img}
                            title={title}
                            content={content}
                        />
                    ))}
                    {cardMap.map(({ Img, title, content }, index) => (
                        <SummaryCard
                            key={index}
                            Img={Img}
                            title={title}
                            content={content}
                        />
                    ))}
                    {cardMap.map(({ Img, title, content }, index) => (
                        <SummaryCard
                            key={index}
                            Img={Img}
                            title={title}
                            content={content}
                        />
                    ))}
                </motion.div>
            </div>
        </div>
    );
}
